"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_EVENT_LABELS = void 0;
exports.activityEventDate = activityEventDate;
exports.groupActivityEventsByDay = groupActivityEventsByDay;
exports.activityActorLabel = activityActorLabel;
exports.activityEventTitle = activityEventTitle;
exports.communicationActivityPresentation = communicationActivityPresentation;
exports.activityEventHeadline = activityEventHeadline;
exports.ACTIVITY_EVENT_LABELS = {
    'report.created': 'דוח נוצר',
    'report.cloned': 'דוח שוכפל',
    'report.published': 'דוח פורסם',
    'report.exported': 'דוח יוצא',
    'report.header_changed': 'כותרת הדוח השתנתה',
    'crm.lead_created': 'ליד נוצר',
    'crm.stage_changed': 'שלב הלקוח השתנה',
    'crm.note_added': 'הערה נוספה',
    'crm.note_updated': 'הערה עודכנה',
    'crm.note_deleted': 'הערה נמחקה',
    'crm.portal_activity': 'פעילות בפורטל הלקוח',
    'crm.visit_activity': 'פעילות ביקור',
    'crm.whatsapp_activity': 'פעילות WhatsApp',
    'crm.call_summary': 'סיכום שיחה נוסף',
    lead_created: 'ליד נוצר',
    stage_changed: 'שלב הלקוח השתנה',
    note_added: 'הערה נוספה',
    note_updated: 'הערה עודכנה',
    note_deleted: 'הערה נמחקה',
    customer_portal_activity: 'פעילות בפורטל הלקוח',
    whatsapp_activity: 'פעילות WhatsApp',
    call_summary: 'סיכום שיחה נוסף',
};
const STATUS_LABELS = new Map([
    ['draft', 'טיוטה'],
    ['queued', 'ממתינה לשליחה'],
    ['sending', 'נשלחת'],
    ['accepted', 'נשלחה'],
    ['sent', 'נשלחה'],
    ['delivered', 'נמסרה'],
    ['read', 'נקראה'],
    ['failed', 'השליחה נכשלה'],
    ['unknown', 'מצב לא ידוע'],
]);
function activityEventDate(value) {
    return value instanceof Date ? value : new Date(value.seconds * 1000);
}
function localDayKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
function groupActivityEventsByDay(events) {
    const groups = [];
    for (const event of events) {
        const date = activityEventDate(event.occurredAt);
        const key = localDayKey(date);
        const current = groups.at(-1);
        if (current?.key === key)
            current.events.push(event);
        else
            groups.push({ key, date, events: [event] });
    }
    return groups;
}
function activityActorLabel(actor) {
    if (actor.displayNameSnapshot)
        return actor.displayNameSnapshot;
    if (actor.kind === 'system')
        return 'מערכת';
    if (actor.kind === 'integration')
        return 'אינטגרציה';
    if (actor.kind === 'customer')
        return 'לקוח';
    if (actor.kind === 'human')
        return 'משתמש';
    return 'גורם לא מזוהה';
}
function metadataLabel(event, key) {
    const value = event.safeMetadata[key];
    return typeof value === 'string' && value.trim() ? value.trim() : null;
}
function activityEventTitle(event) {
    const stageLabel = metadataLabel(event, 'stageLabel');
    if (event.type === 'stage_changed' || event.type === 'crm.stage_changed') {
        const previousStageLabel = metadataLabel(event, 'previousStageLabel');
        if (previousStageLabel && stageLabel)
            return `${previousStageLabel} ← ${stageLabel}`;
        if (stageLabel)
            return `עבר לסטטוס ${stageLabel}`;
    }
    if ((event.type === 'lead_created' || event.type === 'crm.lead_created') && stageLabel) {
        return `ליד נוצר בסטטוס ${stageLabel}`;
    }
    return null;
}
function durationLabel(value) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value < 0)
        return undefined;
    const seconds = Math.floor(value);
    const minutes = Math.floor(seconds / 60);
    return `משך ${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}
function communicationActivityPresentation(event, preview) {
    const channel = event.type === 'crm.phone_call'
        ? 'phone'
        : event.type === 'crm.whatsapp_message'
            ? 'whatsapp'
            : null;
    if (!channel)
        return null;
    const direction = event.safeMetadata.direction;
    if (direction !== 'inbound' && direction !== 'outbound')
        return null;
    const directionLabel = direction === 'inbound' ? 'נכנסת' : 'יוצאת';
    const detail = channel === 'phone'
        ? durationLabel(event.safeMetadata.durationSeconds)
        : preview?.currentStatus ? STATUS_LABELS.get(preview.currentStatus) : undefined;
    return {
        channel,
        direction,
        title: channel === 'phone'
            ? `שיחת טלפון ${directionLabel}`
            : `הודעת WhatsApp ${directionLabel}`,
        ...(detail ? { detail } : {}),
        preview: preview?.state === 'available' && preview.text
            ? preview.text
            : 'הפרטים אינם זמינים',
    };
}
function activityEventHeadline(event, preview) {
    return communicationActivityPresentation(event, preview)?.title
        ?? activityEventTitle(event)
        ?? exports.ACTIVITY_EVENT_LABELS[event.type]
        ?? event.type;
}
